const projects = [
  {
    title: "Conversational AI Chatbot",
    desc:
      "Developed a conversational AI chatbot using NVIDIA's LLaMA‑3‑70B API and LangChain, supporting real‑time multi‑turn dialogues. Integrated session states in Streamlit to maintain chat history, enhancing user satisfaction by 20%.",
    tech: "LLM, NLP, LangChain, Streamlit",
    link: "https://github.com/Chandu2308/Conversational-AI-chatbot-using-Nvidia-API-key" 
  },
  {
    title: "Face‑Recognition using OpenCV & CNNs",
    desc:
      "Built a face recognition system with OpenCV and CNNs, achieving 90% accuracy in real‑time detection for video streams. Leveraged TensorFlow models, reducing false positives by 15%.",
    tech: "OpenCV, TensorFlow, CNNs, scikit‑learn",
    link: "https://github.com/Chandu2308/Face-Recognition-Using-Open-CV-CNN" 
  },
  {
    title: "Sentiment Analysis for Real‑Time Tweets",
    desc:
      "Designed a sentiment analysis pipeline using TextBlob and Pandas, analysing 5,000+ tweets with 85% classification accuracy. Deployed an interactive dashboard using Streamlit & Plotly.",
    tech: "Pandas, TextBlob, Streamlit, Plotly",
    link: "https://github.com/Chandu2308/Sentimental-Analysis-for-RealTime-Tweets" 
  },
  {
    title: "Real‑time Evaluation System",
    desc:
      "AI‑based evaluation for handwritten and typed answers, built around the TROCR model.",
    tech: "Vision‑OCR, Transformer‑OCR (TROCR)",
    link: "#"
  },
];

export default function Projects() {
  return (
    <section id="projects" className="bg-gray-900 py-16 px-6 text-white">
      <h3 className="text-3xl text-red-500 font-bold text-center mb-10">Projects</h3>
      <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
        {projects.map(({ title, desc, tech, link }, i) => (
          <div key={i} className="bg-gray-800 p-5 rounded shadow hover:shadow-lg transition flex flex-col gap-2">
            <h4 className="text-xl font-semibold">{title}</h4>
            <p className="text-sm text-gray-300">{desc}</p>
            <p className="text-xs text-gray-400 italic">{tech}</p>
            {link && link !== "#" && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto text-red-400 hover:text-red-500 underline text-sm"
              >
                View Project
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
